import { useEffect } from "react";

const useBestViewHeight = () => {
  const handleResize = () => {
    const vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty('--vh', `${vh}px`);
  }
  
  const handleOrientation = () => {
    setTimeout(() => { // without delay doesn't work for orientation change
      const vh = window.innerHeight * 0.01;
      document.documentElement.style.setProperty('--vh', `${vh}px`);
    }, 100)
  }
  
  // Updated special variable for best view height on resize and orientation change
  useEffect(() => {
    handleResize()

    window.addEventListener("resize", handleResize);
    window.addEventListener('orientationchange', handleOrientation) 
    return () => {
      window.removeEventListener("resize", handleResize);
      window.removeEventListener('orientationchange', handleOrientation)
    }
  }, [])
}

export default useBestViewHeight